import { createFileRoute } from '@tanstack/react-router';
import { CustomerPortalKnowledgeBaseArticle } from '../../../../../customer-portal/pages/CustomerPortalKnowledgeBaseArticle';
import { usePortalContext } from '../../../../../contexts/PortalContext';

function PortalKnowledgeBaseArticle() {
  const { organizationInfo } = usePortalContext();
  const { articleId } = Route.useParams();

  return (
    <CustomerPortalKnowledgeBaseArticle
      params={{ articleId }}
      organizationInfo={organizationInfo}
      orgSlug={organizationInfo.subdomain}
    />
  );
}

export const Route = createFileRoute('/org/$orgSlug/portal/knowledge-base/$articleId')({
  component: PortalKnowledgeBaseArticle,
});